import { useCallback, useState } from 'react';
import type { MouseEvent } from 'react';
import { hasResource } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import type { MetricRegistryMeta } from '../types';
import { getMetricInfoFields, hasMetricInfoFields } from '../utils/tileMeta';
import { METRIC_INFO_RESOURCE } from '../utils/viewConfig';

export const useMetricInfo = (registry?: MetricRegistryMeta | null) => {
  const canView = hasResource(METRIC_INFO_RESOURCE);
  const fields = getMetricInfoFields(registry);
  const showButton = canView && hasMetricInfoFields(registry);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return {
    showButton,
    open,
    anchorEl,
    handleOpen,
    handleClose,
    ...fields,
  };
};
